import styled from 'styled-components';

import { werkenBij } from 'config/config.json';
import { red, purple, white } from 'styles/colors';
import { fromLarge, fromMedium } from 'styleUtils/mediaQueries';

const {
    watBiedenWijJou: {
        highlight: { itemHeight },
    },
} = werkenBij;

interface Props {
    isPurple?: boolean;
    extraHeightInPixels: number;
}
export const Wrapper = styled.div<Props>`
    background-color: ${({ isPurple }): string => (isPurple ? purple : red)};
    color: ${white};
    padding: 1.5rem 0;

    ${fromMedium`
        padding: 3rem 0 3rem 3rem;
  `}

    ${fromLarge`
        margin-right: 0;
        margin-left: auto;
        max-width: 70%;
        ${({ extraHeightInPixels: extraHeight }): string => {
            return `
            min-height: calc(${itemHeight} + ${extraHeight}px);
            padding: ${extraHeight / 2}px ${extraHeight / 2}px 80px;
        `;
        }}
  `}
`;
